import { useMemo } from 'react';
import { useDrag, useDrop } from 'react-dnd';
import { useTranslation } from 'react-i18next';

import { useFormsClipboard } from '../Clipboard.jsx';
import Icon from '../../../controls/Icon.jsx';
import { Col, Container, Row } from 'react-bootstrap';
import FORMS_DND_ITEMS from '../../../../config/forms-dnd.js';

const Clipboard = () => {
    const [translate] = useTranslation();

    const { items, addItem } = useFormsClipboard();

    const [{ canDrop }, drop] = useDrop(() => ({
        accept: FORMS_DND_ITEMS.NOT_COPIED,
        drop: addItem,
        collect: (monitor) => ({
            canDrop: !!monitor.canDrop()
        })
    }));

    const dropzone = useMemo(() => (
        <div ref={drop} className={`btn btn-sm btn-dropzone-forms w-100 ${canDrop ? 'droppable' : 'pointer-events-none'}`}>
            <span className={`fs-7`}>{translate('OTM_FORMS_CLIPBOARD_DROP')}</span>
        </div>
    ), [drop, canDrop, translate]);

    return (
        <>
            <h2 className='h4 mb-2'>{translate('OTM_FORMS_CLIPBOARD_HEADER')}</h2>
            {dropzone}
            <Container>
                {items.map((item) => {
                    let type = FORMS_DND_ITEMS.ITEM_COPIED;
                    let label = 'OTM_ITEM';
                    if (item.sharedSectionGroupingId) {
                        type = FORMS_DND_ITEMS.SHARED_SECTION_COPIED;
                        label = 'OTM_SECTION';
                    }
                    else if (item.items) {
                        type = FORMS_DND_ITEMS.SECTION_COPIED;
                        label = 'OTM_SECTION';
                    }

                    return (
                        <DragItem
                            type={type}
                            label={label}
                            item={item}
                            key={item._id}
                        />
                    );
                })}
            </Container>
        </>
    );
};

const DragItem = ({
    type,
    label,
    item
}) => {
    const [translate] = useTranslation();
    const [{ isDragging }, drag] = useDrag({
        type,
        item: {
            ...item,
            _storage: {
                ...(item._storage || {})
            },
            _dragging: {
                ...(item._dragging || {}),
                index: undefined
            }
        },
        collect: (monitor) => ({
            isDragging: monitor.isDragging()
        }),
        end: async (droppedItem, monitor) => {
            const didDrop = monitor.didDrop();
            if (!didDrop) {
                if (typeof droppedItem._dragging.onDropOutside === 'function') {
                    await droppedItem._dragging.onDropOutside();
                }
            }

            droppedItem._dragging.index = undefined;
        },
    }, [type, item]);

    return (
        <Row ref={drag} className={`moveable border mt-1 ${isDragging ? 'forms-item-dragging' : ''}`}>
            <Col xs='auto' className='p-0'>
                <Icon icon='DragIndicatorOutlined' className='text-tertiary' />
            </Col>
            <Col className='p-0'>
                <span className='fs-7'>
                    {`[${translate(label)}] ${item.name}`}
                </span>
            </Col>
        </Row>
    );
};

export default Clipboard;